export enum GalleryJustify {
  Left = 'left',
  Center = 'center',
  Right = 'right',
  Evenly = 'evenly',
}

export enum GalleryVisibilityState {
  BeforeEnter = 'beforeEnter',
  Entering = 'entering',
  Visible = 'visible',
  Exiting = 'exiting',
  Out = 'out',
}
